import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "row g-0 align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "display-3 fw-normal mb-3 mb-md-0" }, "自動車貸渡契約書")
], -1)
const _hoisted_4 = { class: "col-12 col-md-7 col-lg-6 col-xl-5" }
const _hoisted_5 = { class: "table table-bordered" }
const _hoisted_6 = { class: "border-1 lh-md" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, " 伝票 ", -1)
const _hoisted_8 = { class: "align-middle px-lg-3" }
const _hoisted_9 = { class: "input-group input-group-sm w-9em" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "No.", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, " 担当者 ", -1)
const _hoisted_13 = { class: "align-middle px-lg-3" }
const _hoisted_14 = ["label"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "invalid-feedback" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, " 配車日 ", -1)
const _hoisted_18 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "table table-bordered" }
const _hoisted_21 = { class: "border-1 lh-md" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "rentCarId",
    class: "form-label"
  }, "車輌")
], -1)
const _hoisted_23 = { class: "align-middle px-lg-3" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "rentCarNo",
    class: "form-label"
  }, " 登録ナンバー ")
], -1)
const _hoisted_27 = { class: "align-middle px-lg-3" }
const _hoisted_28 = { class: "invalid-feedback" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-3",
  rowspan: "3"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "vertical" }, "借受人契約者")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "contractorCompanyName",
    class: "form-label"
  }, [
    /*#__PURE__*/_createTextVNode(" 会社名・"),
    /*#__PURE__*/_createElementVNode("br", { class: "d-lg-none" }),
    /*#__PURE__*/_createTextVNode("団体名 ")
  ])
], -1)
const _hoisted_31 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_32 = { class: "row gx-2 gy-1 align-items-center" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "invalid-feedback" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, "様", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "contractorAddress",
    class: "form-label"
  }, " 住所 ")
], -1)
const _hoisted_37 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "contractorManager",
    class: "form-label"
  }, " 担当者 ")
], -1)
const _hoisted_40 = {
  class: "align-middle px-lg-3",
  colspan: "2"
}
const _hoisted_41 = { class: "row gx-2 gy-1 align-items-center" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "invalid-feedback" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, "様", -1)
const _hoisted_45 = { class: "align-middle px-lg-3" }
const _hoisted_46 = { class: "input-group input-group-sm" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "TEL", -1)
const _hoisted_48 = { class: "invalid-feedback" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-3",
  rowspan: "4"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "vertical" }, "運転手")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "driverName",
    class: "form-label"
  }, " 氏名 ")
], -1)
const _hoisted_51 = { class: "align-middle px-lg-3" }
const _hoisted_52 = { class: "row gx-2 gy-1 align-items-center" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "invalid-feedback" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, "様", -1)
const _hoisted_56 = { class: "align-middle text-center px-lg-3" }
const _hoisted_57 = { class: "form-check form-check-inline me-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "driver_sex_men"
}, " 男 ", -1)
const _hoisted_59 = { class: "form-check form-check-inline me-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "driver_sex_woman"
}, " 女 ", -1)
const _hoisted_61 = { class: "align-middle px-lg-3" }
const _hoisted_62 = { class: "invalid-feedback" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "driverAddress",
    class: "form-label"
  }, " 住所 ")
], -1)
const _hoisted_64 = {
  class: "align-middle px-lg-3",
  colspan: "2"
}
const _hoisted_65 = { class: "invalid-feedback" }
const _hoisted_66 = { class: "align-middle px-lg-3" }
const _hoisted_67 = { class: "input-group input-group-sm" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "TEL", -1)
const _hoisted_69 = { class: "invalid-feedback" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createTextVNode(" 運転免許 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-lg-none" }),
    /*#__PURE__*/_createTextVNode(" 番号 ")
  ])
], -1)
const _hoisted_71 = {
  class: "align-middle px-lg-3",
  colspan: "2"
}
const _hoisted_72 = { class: "invalid-feedback" }
const _hoisted_73 = { class: "align-middle px-lg-3" }
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "invalid-feedback" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "有効期限")
], -1)
const _hoisted_77 = {
  class: "align-middle px-lg-3",
  colspan: "4"
}
const _hoisted_78 = { class: "row gx-2 gy-1 align-items-center row-cols-auto" }
const _hoisted_79 = { class: "col" }
const _hoisted_80 = { class: "invalid-feedback" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, "年の誕生日まで有効", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "貸渡日")
], -1)
const _hoisted_83 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_84 = { class: "row gx-2 gy-1 align-items-center row-cols-auto" }
const _hoisted_85 = { class: "col-4" }
const _hoisted_86 = { class: "invalid-feedback" }
const _hoisted_87 = { class: "col-4" }
const _hoisted_88 = { class: "invalid-feedback" }
const _hoisted_89 = { class: "col-4" }
const _hoisted_90 = { class: "input-group input-group-sm" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "km", -1)
const _hoisted_92 = { class: "invalid-feedback" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "返却日")
], -1)
const _hoisted_94 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_95 = { class: "row gx-2 gy-1 align-items-center row-cols-auto" }
const _hoisted_96 = { class: "col-4" }
const _hoisted_97 = { class: "invalid-feedback" }
const _hoisted_98 = { class: "col-4" }
const _hoisted_99 = { class: "invalid-feedback" }
const _hoisted_100 = { class: "col-4" }
const _hoisted_101 = { class: "input-group input-group-sm" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "km", -1)
const _hoisted_103 = { class: "invalid-feedback" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "車検満了日")
], -1)
const _hoisted_105 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_106 = { class: "row gx-2 gy-1 align-items-center row-cols-auto" }
const _hoisted_107 = { class: "col-5" }
const _hoisted_108 = { class: "invalid-feedback" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "maintenanceDate",
    class: "form-label"
  }, " 点検整備実施 ")
], -1)
const _hoisted_110 = { class: "align-middle px-lg-3" }
const _hoisted_111 = { class: "invalid-feedback" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "maintenancePersonId",
    class: "form-label"
  }, " 整備担当 ")
], -1)
const _hoisted_113 = { class: "align-middle px-lg-3" }
const _hoisted_114 = {
  value: null,
  key: null
}
const _hoisted_115 = ["label"]
const _hoisted_116 = ["value"]
const _hoisted_117 = { class: "invalid-feedback" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "使用目的")
], -1)
const _hoisted_119 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_120 = { class: "row gx-3 align-items-center row-cols-auto" }
const _hoisted_121 = { class: "col-6" }
const _hoisted_122 = ["value"]
const _hoisted_123 = { class: "invalid-feedback" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "dischargeAmount",
    class: "form-label"
  }, "免責金額(万円)")
], -1)
const _hoisted_125 = { class: "align-middle px-lg-3" }
const _hoisted_126 = { class: "invalid-feedback" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "nocSubscriptionAmount",
    class: "form-label"
  }, "NOC加入金額(万円)")
], -1)
const _hoisted_128 = { class: "align-middle px-lg-3" }
const _hoisted_129 = { class: "invalid-feedback" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-3",
  rowspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "vertical" }, "配送先")
], -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "destAddress",
    class: "form-label"
  }, " 住所 ")
], -1)
const _hoisted_132 = {
  class: "align-middle px-lg-3",
  colspan: "3"
}
const _hoisted_133 = { class: "invalid-feedback" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "destManager",
    class: "form-label"
  }, " 氏名 ")
], -1)
const _hoisted_135 = {
  class: "align-middle px-lg-3",
  colspan: "2"
}
const _hoisted_136 = { class: "row gx-2 gy-1 align-items-center" }
const _hoisted_137 = { class: "col" }
const _hoisted_138 = { class: "invalid-feedback" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, "様", -1)
const _hoisted_140 = { class: "align-middle px-lg-3" }
const _hoisted_141 = { class: "input-group input-group-sm" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "TEL", -1)
const _hoisted_143 = { class: "invalid-feedback" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center bg-g05 text-nowrap px-lg-3",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "燃料")
], -1)
const _hoisted_145 = {
  class: "align-middle px-3 px-lg-4",
  colspan: "3"
}
const _hoisted_146 = { class: "range" }
const _hoisted_147 = /*#__PURE__*/_createStaticVNode("<span class=\"empty\">E</span><span class=\"full\">F</span><span class=\"range_20\"></span><span class=\"range_40\"></span><span class=\"range_60\"></span><span class=\"range_80\"></span>", 6)
const _hoisted_153 = { class: "border border-top-0 p-3" }
const _hoisted_154 = /*#__PURE__*/_createStaticVNode("<h4 class=\"d-inline-block h5 fw-normal mb-1 me-2\">お客様への注意事項</h4><p class=\"d-inline-block fs-small\"> ◎貸渡約款に違反した場合は、全責任がお客様にかかりますので御注意下さい。 </p><p class=\"kome\"> ①本書は運行中に必ず携帯し、警察官又は運輸局もしくは陸運支局の職員から請求があった時は呈示しなければならない。 </p><p class=\"kome\"> ②自動車の借受に付随して、貸渡人から運転者の労務供給（運転者の紹介および斡旋を含む。）を受ける事ができない。 </p><p class=\"kome\"> ③受期間中に的確な運行前点検を行うとともに異常を発見した場合には、当該異常カ所の整備を完了した後運行しなければならない。 </p><p class=\"kome\"> ④貸渡自動車に係る事故が発生した場合は、必ず警察に届けるとともに貸渡人にご連絡ください。また貸渡自動車が故障した場合も同様にご連絡ください。 </p><p class=\"kome\"> ⑤貸渡期間が2日以上となる場合には、お客様において的確な運転前点検を行うとともに異常を発見した場合には、貸渡人にご連絡頂くとともに、該当異常カ所の整備を完了した後運行しなければならない。 </p><p class=\"kome\">⑥レンタカーは燃料を満タンにしてお返し下さい。</p><p class=\"kome\"> ⑦貸渡期間中の放置駐車違反により、レンタカー会社が放置違反金納付命令を受けた場合に放置違反金額と付帯費用の実額お支払いいただきます。 </p><p class=\"kome mb-2\"> ⑧その他、お気づきの点等ございましたら貸渡人へご連絡下さい。 </p><p class=\"kome\"> ◎万一事故が起こった場合は、最寄りの警察署で必要は法的手続きを行い、直ちに当社にご連絡下さい。 </p><p class=\"kome\"> 〇貸渡約款29条2公に定める場合、当社がレンタカーについて締結した損害保険契約により、次の限度内の保険金が給付されます。 </p>", 12)
const _hoisted_166 = { class: "list-inline ms-3" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("li", { class: "me-3 align-top" }, "対人保証：無制限", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("li", { class: "me-3 align-top" }, "対物保証：無制限（免責額5万円）", -1)
const _hoisted_169 = { class: "me-3 align-top" }
const _hoisted_170 = { class: "p-0 m-0 ms-1" }
const _hoisted_171 = { class: "me-3 align-top" }
const _hoisted_172 = { class: "p-0 m-0 mx-1" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("small", null, "自走不可能の場合は別途費用発生します", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("li", null, "人身傷害補償：3,000万円", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("h4", { class: "h5 fw-normal" }, "株式会社エースレンタカー", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 〒003-0871 北海道札幌市白石区米里1条2丁目14-14"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("TEL：0120-111-503　FAX：011-595-8132 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RentalContractConfirmModal = _resolveComponent("RentalContractConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", _hoisted_6, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "slipNo",
                      name: "slipNo",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rentalContractEditForm.slipNo) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.rentalContractEditForm.slipNo,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.slipNo.message), 1)
                  ])
                ]),
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    id: "managerId",
                    name: "managerId",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rentalContractEditForm.managerId) = $event)),
                    class: "form-select form-select-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersForSinglePulldownByVue
                      .users[0], (department, id) => {
                      return (_openBlock(), _createElementBlock("optgroup", {
                        label: department.departmentName,
                        key: id
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(department.users, (user) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: user.id,
                            key: user.id
                          }, _toDisplayString(user.name), 9, _hoisted_15))
                        }), 128))
                      ], 8, _hoisted_14))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.rentalContractEditForm.managerId]
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.errors.managerId.message), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "dispatchDate",
                    name: "dispatchDate",
                    class: "form-control form-control-sm",
                    placeholder: "カレンダーから選択",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rentalContractEditForm.dispatchDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.dispatchDate]
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errors.dispatchDate.message), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_20, [
        _createElementVNode("tbody", _hoisted_21, [
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("td", _hoisted_23, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                id: "rentCarId",
                name: "rentCarId",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rentalContractEditForm.rentCarId) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carModelsForPulldownByVue.carModels, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.value,
                    value: option.value
                  }, _toDisplayString(option.text), 9, _hoisted_24))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.rentalContractEditForm.rentCarId]
              ]),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errors.rentCarId.message), 1)
            ]),
            _hoisted_26,
            _createElementVNode("td", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "rentCarNo",
                name: "rentCarNo",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rentalContractEditForm.rentCarNo) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.rentalContractEditForm.rentCarNo,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errors.rentCarNo.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("td", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "contractorCompanyName",
                    name: "contractorCompanyName",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rentalContractEditForm.contractorCompanyName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.contractorCompanyName]
                  ]),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.errors.contractorCompanyName.message), 1)
                ]),
                _hoisted_35
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_36,
            _createElementVNode("td", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "contractorAddress",
                name: "contractorAddress",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rentalContractEditForm.contractorAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.rentalContractEditForm.contractorAddress]
              ]),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.errors.contractorAddress.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_39,
            _createElementVNode("td", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "contractorManager",
                    name: "contractorManager",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rentalContractEditForm.contractorManager) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.contractorManager]
                  ]),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.errors.contractorManager.message), 1)
                ]),
                _hoisted_44
              ])
            ]),
            _createElementVNode("td", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "contractorTel",
                  name: "contractorTel",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rentalContractEditForm.contractorTel) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.rentalContractEditForm.contractorTel]
                ]),
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.errors.contractorTel.message), 1)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_49,
            _hoisted_50,
            _createElementVNode("td", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "driverName",
                    name: "driverName",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rentalContractEditForm.driverName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.driverName]
                  ]),
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.errors.driverName.message), 1)
                ]),
                _hoisted_55
              ])
            ]),
            _createElementVNode("td", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "driver_sex_men",
                  name: "driver_sex",
                  value: "1",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rentalContractEditForm.driverSex) = $event)),
                  checked: ""
                }, null, 512), [
                  [_vModelRadio, _ctx.rentalContractEditForm.driverSex]
                ]),
                _hoisted_58
              ]),
              _createElementVNode("div", _hoisted_59, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "driver_sex_woman",
                  name: "driver_sex",
                  value: "2",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rentalContractEditForm.driverSex) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.rentalContractEditForm.driverSex]
                ]),
                _hoisted_60
              ])
            ]),
            _createElementVNode("td", _hoisted_61, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "driverBirthday",
                name: "driverBirthday",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rentalContractEditForm.driverBirthday) = $event)),
                placeholder: "カレンダーから選択"
              }, null, 512), [
                [_vModelText, _ctx.rentalContractEditForm.driverBirthday]
              ]),
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.errors.driverBirthday.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_63,
            _createElementVNode("td", _hoisted_64, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "driverAddress",
                name: "driverAddress",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rentalContractEditForm.driverAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.rentalContractEditForm.driverAddress]
              ]),
              _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.errors.driverAddress.message), 1)
            ]),
            _createElementVNode("td", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "driverTel",
                  name: "driverTel",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.rentalContractEditForm.driverTel) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.rentalContractEditForm.driverTel]
                ]),
                _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.errors.driverTel.message), 1)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_70,
            _createElementVNode("td", _hoisted_71, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "driverLicenseNo",
                name: "driverLicenseNo",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rentalContractEditForm.driverLicenseNo) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.rentalContractEditForm.driverLicenseNo,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.errors.driverLicenseNo.message), 1)
            ]),
            _createElementVNode("td", _hoisted_73, [
              _withDirectives(_createElementVNode("select", {
                id: "drivingLicenseTypeId",
                name: "drivingLicenseTypeId",
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.rentalContractEditForm.drivingLicenseTypeId) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverLicenseTypesForPulldownByVue.driverLicenseTypes, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.value,
                    value: option.value
                  }, _toDisplayString(option.text), 9, _hoisted_74))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.rentalContractEditForm.drivingLicenseTypeId]
              ]),
              _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.errors.drivingLicenseTypeId.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_76,
            _createElementVNode("td", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "driverLicenseExpireYear",
                    name: "driverLicenseExpireYear",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((
                    _ctx.rentalContractEditForm.driverLicenseExpireYear
                  ) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      
                    _ctx.rentalContractEditForm.driverLicenseExpireYear
                  ,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.errors.driverLicenseExpireYear.message), 1)
                ]),
                _hoisted_81
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_82,
            _createElementVNode("td", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "lentDate",
                    name: "lentDate",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rentalContractEditForm.lentDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.lentDate]
                  ]),
                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.errors.lentDate.message), 1)
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    id: "lentTime",
                    name: "lentTime",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.rentalContractEditForm.lentTime) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.lentTime]
                  ]),
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.errors.lentTime.message), 1)
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      id: "lentDateDrivingDistance",
                      name: "lentDateDrivingDistance",
                      class: "form-control form-control-sm w-8em",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                      _ctx.rentalContractEditForm.lentDateDrivingDistance
                    ) = $event)),
                      placeholder: "走行距離"
                    }, null, 512), [
                      [
                        _vModelText,
                        
                      _ctx.rentalContractEditForm.lentDateDrivingDistance
                    ,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _hoisted_91,
                    _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.errors.lentDateDrivingDistance.message), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_93,
            _createElementVNode("td", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "returnDate",
                    name: "returnDate",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.rentalContractEditForm.returnDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.returnDate]
                  ]),
                  _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.errors.returnDate.message), 1)
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    id: "returnTime",
                    name: "returnTime",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.rentalContractEditForm.returnTime) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.returnTime]
                  ]),
                  _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.errors.returnTime.message), 1)
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      id: "returnDateDrivingDistance",
                      name: "returnDateDrivingDistance",
                      class: "form-control form-control-sm w-8em",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                      _ctx.rentalContractEditForm.returnDateDrivingDistance
                    ) = $event)),
                      placeholder: "走行距離"
                    }, null, 512), [
                      [
                        _vModelText,
                        
                      _ctx.rentalContractEditForm.returnDateDrivingDistance
                    ,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _hoisted_102,
                    _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.errors.returnDateDrivingDistance.message), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_104,
            _createElementVNode("td", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "vehicleInspectionExpiryDate",
                    name: "vehicleInspectionExpiryDate",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.rentalContractEditForm.vehicleInspectionExpiryDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.vehicleInspectionExpiryDate]
                  ]),
                  _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.errors.vehicleInspectionExpiryDate.message), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_109,
            _createElementVNode("td", _hoisted_110, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "maintenanceDate",
                name: "maintenanceDate",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.rentalContractEditForm.maintenanceDate) = $event)),
                placeholder: "カレンダーから選択"
              }, null, 512), [
                [_vModelText, _ctx.rentalContractEditForm.maintenanceDate]
              ]),
              _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.errors.maintenanceDate.message), 1)
            ]),
            _hoisted_112,
            _createElementVNode("td", _hoisted_113, [
              _withDirectives(_createElementVNode("select", {
                id: "maintenancePersonId",
                name: "maintenancePersonId",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.rentalContractEditForm.maintenancePersonId) = $event)),
                class: "form-select form-select-sm"
              }, [
                (_openBlock(), _createElementBlock("option", _hoisted_114)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersForSinglePulldownByVue.users[0], (department, id) => {
                  return (_openBlock(), _createElementBlock("optgroup", {
                    label: department.departmentName,
                    key: id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(department.users, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: user.id,
                        key: user.id
                      }, _toDisplayString(user.name), 9, _hoisted_116))
                    }), 128))
                  ], 8, _hoisted_115))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.rentalContractEditForm.maintenancePersonId]
              ]),
              _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.errors.maintenancePersonId.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_118,
            _createElementVNode("td", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, [
                  _withDirectives(_createElementVNode("select", {
                    id: "usageObjectiveId",
                    name: "usageObjectiveId",
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.rentalContractEditForm.usageObjectiveId) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageObjectivesForPulldownByVue.usageObjectives, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_122))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.rentalContractEditForm.usageObjectiveId]
                  ]),
                  _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.errors.usageObjectiveId.message), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_124,
            _createElementVNode("td", _hoisted_125, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "dischargeAmount",
                name: "dischargeAmount",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.rentalContractEditForm.dischargeAmount) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.rentalContractEditForm.dischargeAmount,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.errors.dischargeAmount.message), 1)
            ]),
            _hoisted_127,
            _createElementVNode("td", _hoisted_128, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "nocSubscriptionAmount",
                name: "nocSubscriptionAmount",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.rentalContractEditForm.nocSubscriptionAmount) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.rentalContractEditForm.nocSubscriptionAmount,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.errors.nocSubscriptionAmount.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_130,
            _hoisted_131,
            _createElementVNode("td", _hoisted_132, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "destAddress",
                name: "destAddress",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.rentalContractEditForm.destAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.rentalContractEditForm.destAddress]
              ]),
              _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.errors.destAddress.message), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_134,
            _createElementVNode("td", _hoisted_135, [
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", _hoisted_137, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "destManager",
                    name: "destManager",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.rentalContractEditForm.destManager) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.rentalContractEditForm.destManager]
                  ]),
                  _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.errors.destManager.message), 1)
                ]),
                _hoisted_139
              ])
            ]),
            _createElementVNode("td", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "destTel",
                  name: "destTel",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.rentalContractEditForm.destTel) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.rentalContractEditForm.destTel]
                ]),
                _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.errors.destTel.message), 1)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_144,
            _createElementVNode("td", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _withDirectives(_createElementVNode("input", {
                  type: "range",
                  id: "fuel",
                  name: "fuel",
                  class: "form-range",
                  min: "0",
                  max: "4",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.rentalContractEditForm.fuel) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.rentalContractEditForm.fuel,
                    void 0,
                    { number: true }
                  ]
                ]),
                _hoisted_147
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_153, [
        _hoisted_154,
        _createElementVNode("ul", _hoisted_166, [
          _hoisted_167,
          _hoisted_168,
          _createElementVNode("li", _hoisted_169, [
            _createTextVNode(" 車輌補償：時価額（免責額 "),
            _createElementVNode("span", _hoisted_170, _toDisplayString(_ctx.rentalContractEditForm.dischargeAmount ? _ctx.rentalContractEditForm.dischargeAmount.toLocaleString() : _ctx.rentalContractEditForm.dischargeAmount), 1),
            _createTextVNode(" 万円） ")
          ]),
          _createElementVNode("li", _hoisted_171, [
            _createTextVNode(" 営業補償：（ "),
            _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.rentalContractEditForm.nocSubscriptionAmount ? _ctx.rentalContractEditForm.nocSubscriptionAmount.toLocaleString() : _ctx.rentalContractEditForm.nocSubscriptionAmount), 1),
            _createTextVNode(" 万円） "),
            _hoisted_173,
            _hoisted_174
          ]),
          _hoisted_175
        ]),
        _hoisted_176,
        _hoisted_177,
        _hoisted_178
      ])
    ]),
    _createVNode(_component_RentalContractConfirmModal)
  ], 64))
}